import React from 'react';
import { BundleTagFont, BundleTagContainer } from './BundleTag.styled';

const BundleTag = (props) => {
    const isIpadPortrait = window.innerWidth >= 660 && window.innerWidth <= 1030;
    const isIpadLandscape = window.innerWidth > 1030 && window.innerWidth <= 1366;
    const isIpadWidth = isIpadPortrait || isIpadLandscape;
    const displayValue = (props.value || '')?.toUpperCase() === 'BUNDLE' && isIpadWidth ? 'B' : (props.value || '');
    return (
        <>
          <BundleTagContainer containerWidth = {isIpadWidth && '20px'}>
                {props?.children ? (
                    props?.children
                ) : (
                    <BundleTagFont
                        lineHeight={isIpadWidth && 1}
                        textTrasnform={'uppercase'}
                        opacity={props.bundleFontOpacity}
                    >
                        {displayValue}
                    </BundleTagFont>
                )}
            </BundleTagContainer>
        </>
    );
};
export default BundleTag;
